import { HttpTransportType, HubConnectionBuilder, LogLevel } from "@microsoft/signalr";
import * as Constants from "common/helpers/constants";
import reduxSignalRMiddleware, { withCallbacks } from "common/realtime/redux-signalr-middleware";
import DocumentAPIResponse from "documents/entities/document/api/response-contracts/document-api-response";
import Session from "users/session/session";
import { addDocument, removeDocument } from "./documents-redux-slice";

export const documentsHubConnection = new HubConnectionBuilder()
  .configureLogging(LogLevel.Debug)
  .withUrl(`${Constants.apiBaseUrl}/documentHub`, {
    skipNegotiation: true,
    transport: HttpTransportType.WebSockets,
    accessTokenFactory: () => Session.loadFromStorage(() => { }).authToken?.value ?? "",
  })
  .withAutomaticReconnect()
  .build();

const toDocument = (payload: unknown) =>
  Object.assign(new DocumentAPIResponse(), payload as object).deserialize();

const callbacks = withCallbacks()
  .add("document-created", (payload: unknown) => (dispatch) => {
    const document = toDocument(payload);
    dispatch(addDocument(document));
  })
  .add("document-updated", (payload: unknown) => (dispatch) => {
    const document = toDocument(payload);
    dispatch(addDocument(document));
  })
  .add("document-deleted", (payload: unknown) => (dispatch) => {
    const document = toDocument(payload);
    dispatch(removeDocument(document));
  });

export const documentsSignalRReduxMiddleware = reduxSignalRMiddleware({
  callbacks,
  connection: documentsHubConnection,
  shouldConnectionStartImmediately: true,
});
